import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetProductFeeTierListResponseDto } from "../../dtos/get-product-fee-tier-list-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetProductFeeTierListQueryParams = {
  options?: UseQueryOptions<GetProductFeeTierListResponseDto>;
};

export const useGetProductFeeTierListQuery = ({
  options
}: UseGetProductFeeTierListQueryParams = {}) => {
  return useQuery({
    queryKey: ProductQueryKeys.getProductFeeTierList().queryKey,
    queryFn: async () => await ProductService.getProductFeeTierList(),
    ...options
  });
};
